import React from 'react';
import AppErrorBoundary from 'components/ErrorBoundaries/AppErrorBoundary';

const withAppErrorBoundary = (WrappedComponent, key) => {
  const appBoundaryHigherOrderComponent = props => (
    <AppErrorBoundary key={ key } origin={ key }>
      <WrappedComponent { ...props } />
    </AppErrorBoundary>
  );
  return appBoundaryHigherOrderComponent;
};

export default withAppErrorBoundary;
